import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import HeaderMenu from '@/components/menu/index.vue';
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'common-header-menu',
  props: {
    bgColor: {
        type: String,
        default: '#2164C9',
    },
    navTopBgColor: {
        type: String,
        default: '#2164C9',
    },
    navBottomBgColor: {
        type: String,
        default: '#2164C9',
    },
},
  setup(__props) {

const props = __props;



const getStyle = computed(() => {
    return `
        --nav-sub-bg-more-color: ${props.bgColor};
        --nav-top-bg-color: ${props.navTopBgColor};
        --nav-bottom-bg-color: ${props.navBottomBgColor};
    `;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HeaderMenu, _mergeProps({ style: _unref(getStyle) }, _ctx.$attrs), null, 16, ["style"]))
}
}

})